<template>
  <section class="auto-quote">
    <tool-bar pageTitle="AutoQuote" />

    <div v-if="!handleBlur" class="auto-quote__placeholder">
      <v-icon size="72" color="primary">mdi-cash-multiple</v-icon>
      <h1>{{ $t('autoQuote.title') }}</h1>
      <p class="auto-quote__subtitle">{{ $t('productCards.descriptions.autoQuote') }}</p>
      <p class="auto-quote__note">{{ $t('autoQuote.underConstruction') }}</p>
    </div>
    <div v-else>
      <img src="../assets/blur_imgs/blur2.png" :alt="$t('extras.blurredImageAlt')">
    </div>
  </section>
</template>

<script>
import ToolBar from '@/components/layout/ToolBar.vue';
import { useCoreStore } from '@/store/coreStore';
import { mapStores } from 'pinia';

// Tela ainda sem produto por tras. Existe para o card da /home ter destino: sem
// rota, o clique nao navega e o AutoQuote nao teria como participar do
// entitlement como os outros - ver a memoria demomode-saiu-blur-por-entitlement.
export default {
  name: 'AutoQuote',
  components: { ToolBar },
  computed: {
    ...mapStores(useCoreStore),
    handleBlur() {
      return this.coreStore.evaluateBlur(this.$options.name)
    },
  },
};
</script>

<style scoped>
/* 7rem de topo: mesma folga que as outras telas deixam para a app bar fixa. */
.auto-quote__placeholder {
  margin-top: 7rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: .6rem;
}

.auto-quote__placeholder h1 {
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.auto-quote__subtitle {
  color: hsl(0, 0%, 65%);
  margin: 0;
}

.auto-quote__note {
  color: hsl(0, 0%, 45%);
  max-width: 34rem;
  margin: .6rem 0 0;
}
</style>
